import { Switch } from "@xola/ui-kit";
import { FormField } from "common";
import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { PackageFormValues } from "./StartTimeRestriction";
import { TimePickerPopover } from "@/components/Common/TimePickerPopover";

export const MinimumDurationField = () => {
    const { values, errors, setFieldValue } = useFormikContext<PackageFormValues>();
    const { minimumTransitDuration } = values;
    const [isChecked, setIsChecked] = useState(minimumTransitDuration !== 0);

    useEffect(() => {
        setIsChecked(minimumTransitDuration !== 0);
    }, [minimumTransitDuration]);

    const handleSwitchChange = (value: boolean) => {
        setIsChecked(value);

        if (value) {
            setFieldValue("minimumTransitDuration", 1);
        } else {
            setFieldValue("minimumTransitDuration", 0);
        }
    };

    return (
        <FormField
            name="durationBetweenEvents"
            label="Duration Restriction Between Events"
            tooltip={
                !isChecked &&
                "Enable to require a minimum amount of time between the end of one event and the start of another."
            }
            placement="top"
        >
            <Switch isChecked={isChecked} onChange={handleSwitchChange} />
            {isChecked ? (
                <span className="ml-2">
                    Require at least{" "}
                    <span data-testid="minimum-duration-field-value">
                        <TimePickerPopover
                            showArrow
                            placement="bottom"
                            value={values.minimumTransitDuration}
                            isError={!!errors.minimumTransitDuration}
                            errorMessage={errors.minimumTransitDuration}
                            onApply={(value: number) => {
                                setFieldValue("minimumTransitDuration", value);
                            }}
                        />{" "}
                    </span>
                    between the completion of one event and the recommended arrival time of the next
                </span>
            ) : (
                <span className="ml-2">No restrictions are active</span>
            )}
        </FormField>
    );
};
